import React, { useState, useRef, useEffect } from "react";
import { Link as ScrollLink } from "react-scroll";
import { FaMapMarkerAlt, FaChevronLeft, FaChevronRight } from "react-icons/fa";
import { motion } from "framer-motion";
import "./AboutUs.css";
//import React, { useState, useEffect } from 'react';
import ContactUs from "./ContactUs";
import ServicesPage from "./ServicesPage";
import { Link } from "react-router-dom";
import Chatbot from "./Chatbot";
import LoginSignupModal from "./LoginSignupModal";
import FeaturedRegions from "./components/FeaturedRegions";
import { auth } from "./firebase";
import { onAuthStateChanged, signOut } from "firebase/auth";
import TestimonialsSection from "./components/testimonials/TestimonialsSection";
import WhatsAppButton from "./components/WhatsAppButton";
const CarouselCard = ({
  dest,
  expandedDestination,
  setExpandedDestination,
}) => {
  const imgContainerRef = useRef(null);
  const slides = Array.isArray(dest.images) ? dest.images : [];
  const scrollBy = (offset) =>
    imgContainerRef.current?.scrollBy({ left: offset, behavior: "smooth" });

  return (
    <div
      key={dest.id}
      style={{
        width: "460px",
        background: "#fff",
        borderRadius: "12px",
        overflow: "hidden",
        boxShadow: "0 6px 12px rgba(0,0,0,0.1)",
        scrollSnapAlign: "start",
        flex: "0 0 auto",
      }}
    >
      <div style={{ position: "relative" }}>
        <button
          onClick={() => scrollBy(-460)}
          style={{
            position: "absolute",
            top: "50%",
            left: "8px",
            transform: "translateY(-50%)",
            background: "rgba(0,0,0,0.5)",
            border: "none",
            borderRadius: "50%",
            padding: "8px",
            cursor: "pointer",
            zIndex: 1,
          }}
        >
          <FaChevronLeft style={{ color: "white" }} />
        </button>

        <div
          ref={imgContainerRef}
          style={{
            display: "flex",
            overflowX: "auto",
            scrollSnapType: "x mandatory",
          }}
        >
          {slides.map((src, idx) => (
            // eslint-disable-next-line jsx-a11y/img-redundant-alt
            <img
              key={idx}
              src={src}
              alt={`${dest.title} image ${idx + 1}`}
              style={{
                width: "460px",
                height: "280px",
                objectFit: "cover",
                flex: "0 0 auto",
                scrollSnapAlign: "start",
              }}
            />
          ))}
        </div>

        <button
          onClick={() => scrollBy(460)}
          style={{
            position: "absolute",
            top: "50%",
            right: "8px",
            transform: "translateY(-50%)",
            background: "rgba(0,0,0,0.5)",
            border: "none",
            borderRadius: "50%",
            padding: "8px",
            cursor: "pointer",
            zIndex: 1,
          }}
        >
          <FaChevronRight style={{ color: "white" }} />
        </button>
      </div>

      <div style={{ padding: "20px" }}>
        <h3 style={{ fontSize: "22px", fontWeight: "bold", color: "#1F2937" }}>
          {dest.title}
        </h3>
        <p style={{ color: "#4B5563", marginTop: "12px" }}>{dest.summary}</p>
        {expandedDestination === dest.id && (
          <div
            style={{ marginTop: "16px", color: "#374151", lineHeight: "1.6" }}
          >
            <ul>
              {dest.details.map((item, i) => (
                <li key={i}>{item}</li>
              ))}
            </ul>
            <p>
              <strong>📆 Best Time:</strong> November to March
            </p>
            <p>
              <strong>🚗 Travel:</strong> Well-connected via air, trains, and
              scenic roads
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

const Home = () => {
  const homeRef = useRef();
  const itineraryRef = useRef();
  const featuredRef = useRef();
  const servicesRef = useRef();
  const aboutRef = useRef();
  const aboutUsRef = useRef();
  const contactRef = useRef();
  const [isVisible, setIsVisible] = useState(false);
  const [expandedDestination, setExpandedDestination] = useState(null);
  const [menuOpen, setMenuOpen] = useState(false);
  const [isMobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [hover, setHover] = useState(false);
  const menuRef = useRef();
  const [showAccountDropdown, setShowAccountDropdown] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [modalTab, setModalTab] = useState("login"); // or 'signup'
  const partnerRef = useRef();
  const [currentUser, setCurrentUser] = useState(null);
  const images = ['/alba1.jpg', '/alba2.jpg', '/alba3.jpg', '/alba4.jpg', '/ando2.jpg', '/ando4.jpg', '/ani1.jpg', '/austria3.jpg', '/bah1.jpg', '/bah3.jpg', '/bh4.jpg', '/blog-background.jpg', '/blog-srilanka-besttime.jpg', '/blog-thailand7days.jpg', '/bulgaria3.jpg', '/cro5.jpg', '/dashboard-bg.jpg', '/denm3.jpg', '/goa2.jpg', '/greece4.jpg', '/ice1.jpg', '/ice4.jpg', '/Indonesia5.jpg']
  //const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  // ADD THIS EFFECT BLOCK HERE:
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImageIndex((prevIndex) => 
        prevIndex === images.length - 1 ? 0 : prevIndex + 1
      );
    }, 5000); // 15 seconds

    return () => clearInterval(interval); // Cleanup to prevent memory leaks
  }, [images.length]);
  // --- put these near the top of Home() (with your other state/hooks) ---

  const accountRef = useRef(null);

  const accountTimer = useRef(null);

  const openAccount = () => {
    if (accountTimer.current) clearTimeout(accountTimer.current);
    setShowAccountDropdown(true);
  };
  const closeAccount = () => {
    accountTimer.current = setTimeout(() => setShowAccountDropdown(false), 200);
  };

  useEffect(() => {
    const onDocClick = (e) => {
      if (accountRef.current && !accountRef.current.contains(e.target)) {
        setShowAccountDropdown(false);
      }
      // don't close if you clicked the hamburger button itself
      if (
        menuRef.current &&
        !menuRef.current.contains(e.target) &&
        e.target.id !== "tx-ham"
      ) {
        setMobileMenuOpen(false);
      }
    };
    const onEsc = (e) => {
      if (e.key === "Escape") {
        setShowAccountDropdown(false);
        setMobileMenuOpen(false);
      }
    };
    document.addEventListener("mousedown", onDocClick);
    document.addEventListener("keydown", onEsc);
    return () => {
      document.removeEventListener("mousedown", onDocClick);
      document.removeEventListener("keydown", onEsc);
    };
  }, []);

  useEffect(
    () => () => accountTimer.current && clearTimeout(accountTimer.current),
    []
  );
  // --- end setup ---

  // console.log("API base =", process.env.REACT_APP_API_BASE);
  useEffect(() => {
    const unsub = onAuthStateChanged(auth, (u) => setCurrentUser(u));
    return () => unsub();
  }, []);

  const handleLogout = async () => {
    try {
      await signOut(auth);
    } finally {
      setShowAccountDropdown(false);
    }
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setMobileMenuOpen(false);
      }
    };

    if (isMobileMenuOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isMobileMenuOpen]);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => setIsVisible(entry.isIntersecting),
      { threshold: 0.1 }
    );

    if (aboutRef.current) observer.observe(aboutRef.current);

    return () => {
      if (aboutRef.current) observer.unobserve(aboutRef.current);
    };
  }, []);

  // Carousel renderer
  const renderCarousel = (list) => (
    <div
      style={{
        display: "flex",
        gap: "24px",
        overflowX: "auto",
        scrollSnapType: "x mandatory",
        paddingBottom: "16px",
      }}
    >
      {list.map((dest) => (
        <CarouselCard
          key={dest.id}
          dest={dest}
          expandedDestination={expandedDestination}
          setExpandedDestination={setExpandedDestination}
        />
      ))}
    </div>
  );

  return (
    <div
      style={{
        position: "relative",
        minHeight: "100vh",
        width: "100vw",
        overflowX: "hidden",
      }}
    >
      {/* ================= HEADER ================= */}
      <header
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "100%",
          color: "white",
          zIndex: 9999,
          padding: "12px 24px",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          boxShadow: "0 8px 12px rgba(0,0,0,0.6)",
          backdropFilter: "blur(6px)",
          backgroundColor: "rgba(0,0,0,0.35)",
        }}
      >
        {/* Brand */}
        <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
          <img src="/travxplogo.jpg" alt="TravXplo" style={{ height: 40 }} />
          <span style={{ fontWeight: "bold", fontSize: 20 }}>TravXplo</span>
        </div>

        {/* Right: Account + Hamburger */}
        <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
          {/* ===== Account (stays on navbar) ===== */}
          <div
            ref={accountRef}
            style={{
              position: "relative",
              display: "inline-block",
              paddingBottom: 10,
            }}
            onMouseEnter={openAccount}
            onMouseLeave={closeAccount}
          >
            <button
              onClick={() => setShowAccountDropdown((v) => !v)}
              style={{
                background: "transparent",
                border: "none",
                color: "white",
                fontWeight: 500,
                cursor: "pointer",
                display: "inline-flex",
                alignItems: "center",
                gap: 8,
              }}
              aria-haspopup="menu"
              aria-expanded={showAccountDropdown}
            >
              {currentUser?.photoURL && (
                <img
                  src={currentUser.photoURL}
                  alt="avatar"
                  style={{
                    width: 22,
                    height: 22,
                    borderRadius: "50%",
                    border: "1px solid rgba(255,255,255,0.25)",
                    objectFit: "cover",
                  }}
                />
              )}
              {currentUser?.displayName
                ? currentUser.displayName.split(" ")[0]
                : "Account"}{" "}
              ▾
            </button>
            {showAccountDropdown && (
              <div
                onMouseEnter={openAccount}
                onMouseLeave={closeAccount}
                style={{
                  position: "absolute",
                  top: "calc(100% + 8px)",
                  right: "-70px", // moves dropdown box fully to right
                  background: "rgba(0, 0, 0, 0.45)",
                  padding: "12px 16px",
                  borderRadius: "10px",
                  boxShadow: "0 8px 20px rgba(0,0,0,0.45)",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "flex-start", // keep text aligned properly
                  gap: "8px",
                  zIndex: 10000,
                  minWidth: "140px",
                  whiteSpace: "nowrap",
                  transform: "translateY(0)",
                }}
                role="menu"
              >
                {/* {showAccountDropdown && (
              <div
                onMouseEnter={openAccount}
                onMouseLeave={closeAccount}
                style={{
                  position: "absolute",
                  top: "100%",
                  right: 0,
                  marginTop: 4,
                  background: "rgba(0, 0, 0, 0.45)",
                  padding: "10px 16px",
                  borderRadius: 10,
                  boxShadow: "0 8px 18px rgba(0,0,0,0.35)",
                  display: "flex",
                  flexDirection: "column",
                  gap: 8,
                  zIndex: 10000,
                  minWidth: 180,
                  whiteSpace: "nowrap",
                }}
                role="menu"
              > */}
                {currentUser ? (
                  <>
                    <Link
                      to="/dashboard"
                      onClick={() => setShowAccountDropdown(false)}
                      style={{
                        color: "#E5E7EB",
                        textDecoration: "none",
                        fontWeight: 500,
                        padding: "6px 0",
                      }}
                      role="menuitem"
                    >
                      Dashboard
                    </Link>
                    <button
                      onClick={() => {
                        setShowAccountDropdown(false);
                        handleLogout();
                      }}
                      style={{
                        background: "transparent",
                        border: "none",
                        color: "#FCA5A5",
                        fontWeight: 700,
                        cursor: "pointer",
                        padding: "6px 0",
                      }}
                      role="menuitem"
                    >
                      Logout
                    </button>
                  </>
                ) : (
                  <>
                    <button
                      onClick={() => {
                        setShowAccountDropdown(false);
                        setModalTab("login");
                        setShowModal(true);
                      }}
                      style={{
                        background: "transparent",
                        border: "none",
                        color: "#60A5FA",
                        fontWeight: 600,
                        cursor: "pointer",
                        padding: "6px 0",
                      }}
                      role="menuitem"
                    >
                      Login
                    </button>
                    <button
                      onClick={() => {
                        setShowAccountDropdown(false);
                        setModalTab("signup");
                        setShowModal(true);
                      }}
                      style={{
                        background: "transparent",
                        border: "none",
                        color: "#60A5FA",
                        fontWeight: 600,
                        cursor: "pointer",
                        padding: "6px 0",
                      }}
                      role="menuitem"
                    >
                      Sign Up
                    </button>
                  </>
                )}
              </div>
            )}
          </div>

          {/* ===== Hamburger (everything else) ===== */}
          <button
            id="tx-ham"
            onClick={() => setMobileMenuOpen(!isMobileMenuOpen)}
            aria-label="Toggle menu"
            style={{
              background: "rgba(0,0,0,0.45)",
              color: "#fff",
              border: "none",
              borderRadius: "50%",
              width: 42,
              height: 42,
              fontSize: 22,
              lineHeight: "42px",
              cursor: "pointer",
              boxShadow: "0 4px 10px rgba(0,0,0,0.35)",
            }}
          >
            {isMobileMenuOpen ? "✖" : "☰"}
          </button>
        </div>
      </header>

      {/* ================= HAMBURGER DROPDOWN ================= */}
      {isMobileMenuOpen && (
        <div
          ref={menuRef}
          style={{
            position: "fixed",
            top: 64,
            right: 16,
            width: 320,
            maxWidth: "calc(100% - 32px)",
            background: "rgba(0,0,0,0.55)", // Slightly darker for better readability
            backdropFilter: "blur(12px)",
            padding: "20px 16px",
            zIndex: 9998,
            display: "flex",
            flexDirection: "column",
            gap: "10px",
            borderRadius: "16px",
            boxShadow: "0 12px 30px rgba(0,0,0,0.5)",
            border: "1px solid rgba(255, 255, 255, 0.1)",
          }}
        >
          {[
            { label: "Home", id: "home", isExternal: false },
            { label: "Services", id: "planner", isExternal: false },
            { label: "Featured Destinations", id: "destinations", isExternal: false },
            { label: "Hotel Collaborations", id: "hotel-collabs", isExternal: true, path: "/collaborations" },
            { label: "Partner With Us", id: "influencer-cta", isExternal: false },
            { label: "Globe", id: "globe", isExternal: true, path: "/globe" },
            { label: "Blogs", id: "blogs", isExternal: true, path: "/blogs" },
            { label: "Contact Us", id: "contact", isExternal: false },
          ].map((item) => (
            <a
              key={item.label}
              href={item.isExternal ? item.path : `#${item.id}`}
              target={item.isExternal ? "_blank" : "_self"}
              rel={item.isExternal ? "noopener noreferrer" : ""}
              onClick={() => setMobileMenuOpen(false)}
              style={{
                color: "white",
                textDecoration: "none",
                fontSize: "19px",
                fontWeight: 500,
                padding: "12px 15px",
                borderRadius: "10px",
                fontFamily: "'Cormorant Garamond', serif", // Consistent with your new branding
                transition: "all 0.3s ease",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.background = "rgba(255,255,255,0.15)";
                e.currentTarget.style.color = "#60A5FA";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.background = "transparent";
                e.currentTarget.style.color = "white";
              }}
            >
              {item.label}
            </a>
          ))}
          {/* <a
            href="/blogs"
            target="_blank"
            rel="noopener noreferrer"
            onClick={() => setMobileMenuOpen(false)}
            style={{
              color: "white",
              textDecoration: "none",
              fontSize: 18,
              fontWeight: 500,
              padding: "10px 8px",
              borderRadius: 8,
            }}
            onMouseEnter={(e) => (e.currentTarget.style.color = "#60A5FA")}
            onMouseLeave={(e) => (e.currentTarget.style.color = "white")}
          >
            Blogs
          </a> */}
          {/* <a
            href="/globe"
            target="_blank"
            rel="noopener noreferrer"
            onClick={() => setMobileMenuOpen(false)}
            style={{
              color: "white",
              textDecoration: "none",
              fontSize: 18,
              fontWeight: 500,
              padding: "10px 8px",
              borderRadius: 8,
            }}
            onMouseEnter={(e) => (e.currentTarget.style.color = "#60A5FA")}
            onMouseLeave={(e) => (e.currentTarget.style.color = "white")}
          >
            Globe
          </a> */}
          {/* <a
            href="/PricingPlans"
            target="_blank"
            rel="noopener noreferrer"
            onClick={() => setMobileMenuOpen(false)}
            style={{
              color: "white",
              textDecoration: "none",
              fontSize: 18,
              fontWeight: 500,
              padding: "10px 8px",
              borderRadius: 8,
            }}
            onMouseEnter={(e) => (e.currentTarget.style.color = "#60A5FA")}
            onMouseLeave={(e) => (e.currentTarget.style.color = "white")}
          >
            Generate Itinerary
          </a> */}
        </div>
      )}

      {/* ================= AUTH MODAL (mount once) ================= */}
      {showModal && (
        <div style={{ position: "fixed", inset: 0, zIndex: 2147483647 }}>
          <LoginSignupModal
            onClose={() => setShowModal(false)}
            initialTab={modalTab}
          />
        </div>
      )}

      {/* Background Image */}
      <div
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          zIndex: -10,
          backgroundImage: `url(${images[currentImageIndex]})`, // Changed to dynamic index
          backgroundSize: "cover",
          backgroundPosition: "center",
          transition: "background-image 1.5s ease-in-out", // Added smooth transition
        }}
      />
      
      {/* Overlay for dark tint */}
      <div
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          backgroundColor: "rgba(0,0,0,0.3)",
          zIndex: -1,
        }}
      />

      {/* Navbar */}
      {/* <header style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '24px' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
          <img src="/travxplogo.jpg" alt="TravXplo" style={{ height: '60px', filter: 'drop-shadow(0 4px 6px rgba(0,0,0,0.2))'}} />
          <span style={{ color: 'white', fontWeight: '700', fontSize: '24px', textShadow: '2px 2px 4px rgba(0,0,0,0.5)'}}>TravXplo</span>
        </div>
      </header> */}

      {/* Hero Section */}
      <section
      id="home"
      ref={homeRef}
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center", // Centers the entire block horizontally
        justifyContent: "center",
        textAlign: "center", // Centers the text lines
        padding: "160px 24px 100px", // Added top padding to clear the fixed header
        minHeight: "100vh",
        width: "100vw",
        boxSizing: "border-box",
      }}
      >
      <div style={{ maxWidth: "900px", display: "flex", flexDirection: "column", gap: "24px" }}>
        <h1
          style={{
            fontSize: "52px", // Increased size for Cormorant Garamond
            fontWeight: "bold",
            color: "white",
            lineHeight: "1.2",
            fontFamily: "'Cormorant Garamond', serif",
          }}
        >
          Turn Your Travel Ideas into Real Journeys!
        </h1>
        
        <p style={{ 
          fontSize: "28px", 
          color: "#F5F5F2", 
          maxWidth: "700px", 
          margin: "0 auto",
          fontweight: "800",
          fontFamily: "'Cormorant Garamond', serif",
          lineHeight: "1.6"
        }}>
          Free AI itineraries & personalized trip planning support.
        </p>

        {/* Feature List - Centered */}
        <div style={{ 
          color: "white", 
          fontSize: "20px", 
          display: "flex", 
          fontweight: "bold",
          flexDirection: "column", 
          gap: "8px",
          alignItems: "center" 
        }}>
          <span>🌍 Free AI Itineraries</span>
          <span>🧳 Personalized Trip Planning</span>
          <span>🏨 Hotel & Travel Collaborations</span>
        </div>

        {/* Buttons Container */}
        {/* 1. Add this Style Block to handle the mobile transition */}
        <style>
          {`
            @media (max-width: 768px) {
              .hero-btns-container {
                flex-direction: column !important;
                align-items: center !important;
                width: 100%;
              }
              .hero-btns-container a, 
              .hero-btns-container button {
                width: 80%; /* Makes buttons wider and consistent on mobile */
                text-align: center;
              }
            }
          `}
        </style>

        {/* 2. Updated Buttons Container - Balanced Standard Size */}
        <div 
          className="hero-btns-container" 
          style={{ 
            display: "flex", 
            gap: "20px", 
            justifyContent: "center", 
            marginTop: "30px",
            fontWeight: "bold", // Fixed typo: fontWeight
            flexWrap: "wrap",
            width: "100%"
          }}
        >
          {/* Primary Button: Generate Free Itinerary */}
          <a
            href="/PricingPlans"
            target="_blank"
            rel="noopener noreferrer"
            style={{
              padding: "14px 32px", // Reduced from 16px 12px for better horizontal balance
              backgroundColor: "transparent",
              color: "white",
              fontSize: "18px", // Standard readable size
              fontWeight: "bold",
              borderRadius: "50px",
              border: "2px solid white",
              cursor: "pointer",
              transition: "all 0.3s ease",
              fontFamily: "'Cormorant Garamond', serif",
              textDecoration: "none",
              display: "inline-block",
              boxSizing: "border-box",
              textAlign: "center"
            }}
            onMouseOver={(e) => {
              e.target.style.backgroundColor = "white";
              e.target.style.color = "#1D4ED8";
              e.target.style.transform = "translateY(-3px)";
            }}
            onMouseOut={(e) => {
              e.target.style.backgroundColor = "transparent";
              e.target.style.color = "white";
              e.target.style.transform = "translateY(0)";
            }}
          >
            Generate Free Itinerary
          </a>

          {/* Secondary Button: Plan My Trip */}
          <Link
            to="/plan-your-trip"
            style={{
              padding: "14px 32px", // Reduced significantly from 22px 42px to match the other button
              backgroundColor: "transparent",
              color: "white",
              fontSize: "18px", // Reduced from 24px to match the other button
              fontWeight: "bold",
              borderRadius: "50px",
              border: "2px solid white",
              cursor: "pointer",
              transition: "all 0.3s ease",
              fontFamily: "'Cormorant Garamond', serif",
              boxSizing: "border-box",
              textDecoration: "none",
              display: "inline-block",
              textAlign: "center"
            }}
            onMouseOver={(e) => {
              e.target.style.backgroundColor = "white";
              e.target.style.color = "#1D4ED8";
              e.target.style.transform = "translateY(-3px)";
            }}
            onMouseOut={(e) => {
              e.target.style.backgroundColor = "transparent";
              e.target.style.color = "white";
              e.target.style.transform = "translateY(0)";
            }}
          >
            Plan My Trip
          </Link>
        </div>
      </div>
      </section>

      <div ref={servicesRef}>
        <ServicesPage />
      </div>
      {/* India Destinations Carousel */}
      {/* <section
        id="destinations"
        ref={featuredRef}
        style={{
          padding: "60px 24px",
          backgroundColor: "rgba(255,255,255,0.95)",
        }}
      >
        <h2
          style={{
            fontSize: "32px",
            fontWeight: "bold",
            textAlign: "center",
            color: "#1F2937",
            marginBottom: "32px",
          }}
        >
          🗺️ Featured Destinations in India
        </h2>
        {renderCarousel(demoDestinations)}
      </section> */}

      {/* Global Destinations Carousel */}
      {/* <section
        style={{
          padding: "60px 24px",
          backgroundColor: "rgba(255,255,255,0.95)",
        }}
      >
        <h2
          style={{
            fontSize: "32px",
            fontWeight: "bold",
            textAlign: "center",
            color: "#1F2937",
            marginBottom: "32px",
          }}
        >
          🌍 Featured Destinations Across Asia
        </h2>
        {renderCarousel(globalDestinations)}
      </section> */}

      {/* Europe Destinations Carousel */}
      {/* <section
        style={{
          padding: "60px 24px",
          backgroundColor: "rgba(255,255,255,0.95)",
        }}
      >
        <h2
          style={{
            fontSize: "32px",
            fontWeight: "bold",
            textAlign: "center",
            color: "#1F2937",
            marginBottom: "32px",
          }}
        >
          🌍 Featured Destinations Across Europe
        </h2>
        {renderCarousel(europeanDestinations)}
      </section> */}
      <div
        id="destinations"
        // style={{
        //   backgroundColor: "rgba(255,255,255,0.5)",
        // }}
      >
        <FeaturedRegions />
      </div>

      <div id="testimonials">
        <TestimonialsSection />
      </div>

      {/* <section
        style={{
          textAlign: "center",
          padding: "40px 24px",
          backgroundColor: "#f0f4f8",
        }}
      >
        <h2
          style={{
            fontSize: "28px",
            fontWeight: "bold",
            marginBottom: "20px",
            color: "#1f2937",
          }}
        >
          Explore More with Our Blog
        </h2>
        <Link to="/blogs">
          <button
            style={{
              backgroundColor: "#1D4ED8",
              color: "white",
              padding: "14px 36px",
              borderRadius: "8px",
              fontSize: "16px",
              fontWeight: "600",
              border: "none",
              cursor: "pointer",
              boxShadow: "0 4px 8px rgba(0,0,0,0.15)",
              transition: "transform 0.2s ease-in-out",
            }}
            onMouseOver={(e) => (e.target.style.transform = "scale(1.05)")}
            onMouseOut={(e) => (e.target.style.transform = "scale(1)")}
          >
            📖 Read Our Travel Blog
          </button>
        </Link>
      </section> */}
      {/* ===================== TRAVEL INFLUENCER CTA (SEPARATE SECTION) ===================== */}
      <section
        id="influencer-cta"
        style={{
          position: "relative",
          padding: "90px 20px",
          backgroundImage: "url('/influencer-home-bg.jpg')",
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
        }}
      >
        {/* add the style tag for media query */}
        <style>
          {`
      @media (max-width: 768px) {
        #influencer-cta .cards-wrapper {
          flex-direction: column;
          gap: 20px;
        }
      }
    `}
        </style>
        {/* soft overlay */}
        <div
          style={{
            position: "absolute",
            inset: 0,
            background: "rgba(0,0,0,0.35)",
          }}
        />

        {/* cards wrapper */}
        <div
          style={{
            position: "relative",
            maxWidth: "1200px",
            margin: "0 auto",
            display: "flex",
            gap: "32px",
            flexWrap: "wrap", // allows stacking on smaller screens
            justifyContent: "center",
          }}
        >
          {/* Partner With Us Card */}
          <div
            style={{
              flex: "1 1 300px", // grows but won’t shrink below 300px
              minWidth: "300px",
              background: "rgba(255,255,255,0.85)",
              borderRadius: "16px",
              boxShadow: "0 10px 25px rgba(0,0,0,0.15)",
              padding: "40px 32px",
              textAlign: "center",
            }}
          >
            <h2
              style={{
                fontSize: "32px",
                marginBottom: "12px",
                color: "#111827",
              }}
            >
              Explore More With Our Blogs
            </h2>
            <p
              style={{
                fontSize: "18px",
                marginBottom: "26px",
                color: "#374151",
              }}
            >
              Your next adventure starts with a read! Dive into curated travel
              guides, hacks, and tales.
            </p>

            <Link to="/blogs">
              <button
                style={{
                  backgroundColor: "#111827",
                  color: "#fff",
                  padding: "12px 24px",
                  fontSize: "16px",
                  borderRadius: "8px",
                  border: "none",
                  cursor: "pointer",
                }}
                onMouseOver={(e) => (e.target.style.transform = "scale(1.05)")}
                onMouseOut={(e) => (e.target.style.transform = "scale(1)")}
              >
                Read Our Blogs
              </button>
            </Link>
          </div>
          {/* Partner With Us Card */}
          <div
            style={{
              flex: "1 1 300px", // grows but won’t shrink below 300px
              minWidth: "300px",
              background: "rgba(255,255,255,0.85)",
              borderRadius: "16px",
              boxShadow: "0 10px 25px rgba(0,0,0,0.15)",
              padding: "40px 32px",
              textAlign: "center",
            }}
          >
            <h2
              style={{
                fontSize: "32px",
                marginBottom: "12px",
                color: "#111827",
              }}
            >
              Partner With Us
            </h2>
            <p
              style={{
                fontSize: "18px",
                marginBottom: "26px",
                color: "#374151",
              }}
            >
              Are you a boutique hotel, luxury resort, homestay, or villa
              looking to grow your visibility and bookings? TravXplo offers
              exclusive influencer partnerships, digital marketing, and verified
              listings. Let’s work together!
            </p>

            <Link to="/HotelCollabForm">
              <button
                style={{
                  backgroundColor: "#111827",
                  color: "#fff",
                  padding: "12px 24px",
                  fontSize: "16px",
                  borderRadius: "8px",
                  border: "none",
                  cursor: "pointer",
                }}
                onMouseOver={(e) => (e.target.style.transform = "scale(1.05)")}
                onMouseOut={(e) => (e.target.style.transform = "scale(1)")}
              >
                Partner With Us
              </button>
            </Link>
          </div>

          {/* Influencer Card */}
          <div
            style={{
              flex: "1 1 300px",
              minWidth: "300px",
              background: "rgba(255,255,255,0.85)",
              borderRadius: "16px",
              boxShadow: "0 10px 25px rgba(0,0,0,0.15)",
              padding: "40px 32px",
              textAlign: "center",
            }}
          >
            <h2
              style={{
                fontSize: "32px",
                marginBottom: "12px",
                color: "#111827",
              }}
            >
              Are You a Travel Influencer?
            </h2>
            <p
              style={{
                fontSize: "18px",
                marginBottom: "26px",
                color: "#374151",
              }}
            >
              We love working with creators who inspire wanderlust! Join our
              exclusive network of travel storytellers and grow with us.
            </p>

            <Link to="/join-influencer">
              <button
                style={{
                  backgroundColor: "#111827",
                  color: "#fff",
                  padding: "12px 24px",
                  fontSize: "16px",
                  borderRadius: "8px",
                  border: "none",
                  cursor: "pointer",
                }}
                onMouseOver={(e) => (e.target.style.transform = "scale(1.05)")}
                onMouseOut={(e) => (e.target.style.transform = "scale(1)")}
              >
                I’m an Influencer
              </button>
            </Link>
          </div>
        </div>
      </section>
      {/* About Us Section */}

      <section
        id="aboutus"
        ref={(el) => {
          aboutRef.current = el;
          aboutUsRef.current = el;
        }}
        style={{
          position: "relative",
          overflow: "hidden",
          padding: "60px 24px",
          minHeight: "100vh",
        }}
      >
        {/* Fix: Dark overlay to block global background image */}
        <div
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            // backgroundColor: "#000", // solid black
            backdropFilter: "blur(2px)",
            zIndex: -9,
          }}
        ></div>

        <h2
          style={{
            fontSize: "32px",
            fontWeight: "bold",
            textAlign: "center",
            color: "#fff",
            marginBottom: "40px",
            textShadow: "1px 1px 3px rgba(0,0,0,0.3)",
          }}
        >
          Meet TravXplo
        </h2>

        {/* Circle-to-Card Reveal */}
        <div className="circle-card-container">
          {[
            {
              icon: "🧬",
              title: "Our DNA",
              full: "TravXplo is not just a travel platform, it’s a revolution. Born in India and powered by AI, we’re a team of explorers and tech dreamers designing smarter journeys. Our passion? Making travel planning seamless and meaningful for both travelers and hospitality brands.",
            },
            {
              icon: "🌠",
              title: "Vision for the Future",
              full: "To become the world’s most inspiring and intelligent travel planning platform, connecting explorers, hotels, and storytellers through AI-driven adventures and real-world experiences.",
            },
            {
              icon: "🎯",
              title: "Our Mission in Motion",
              full: "To simplify and elevate travel with AI-powered recommendations, optimized itineraries, and a shared space where travelers, hoteliers, and creators thrive together.",
            },
          ].map((item, i) => (
            <motion.div
              key={i}
              className="about-circle-card"
              whileHover={{ scale: 1.2 }}
            >
              <div className="card-front">
                <div style={{ fontSize: "32px", marginBottom: "8px" }}>
                  {item.icon}
                </div>
                <h4
                  style={{
                    fontSize: "16px",
                    fontWeight: "600",
                    marginBottom: "8px",
                  }}
                >
                  {item.title}
                </h4>
              </div>
              <div className="card-back">
                <div style={{ fontSize: "32px", marginBottom: "8px" }}>
                  {item.icon}
                </div>
                <h4
                  style={{
                    fontSize: "16px",
                    fontWeight: "600",
                    marginBottom: "8px",
                  }}
                >
                  {item.title}
                </h4>
                <p>{item.full}</p>
              </div>
            </motion.div>
          ))}
        </div>

        {/* Updated Flip Card Section with only "Key Features" */}
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            marginTop: "40px",
          }}
        >
          <div
            className="flip-card-wrapper"
            style={{ transform: "scale(1.25)" }}
          >
            <div className="flip-card">
              <div className="flip-card-inner">
                <div className="flip-card-front">
                  <div style={{ fontSize: "40px", marginBottom: "10px" }}>
                    🚀
                  </div>
                  <h4 style={{ fontSize: "18px", fontWeight: "600" }}>
                    Key Features
                  </h4>
                </div>
                <div className="flip-card-back">
                  <ul
                    style={{
                      padding: "20px",
                      fontSize: "14px",
                      lineHeight: "1.8",
                      textAlign: "left",
                    }}
                  >
                    {[
                      "✈️ AI Itinerary Generator with instant, personalized day-by-day plans.",
                      "📩 One-click PDF export and easy share via email or link",
                      "🌤️ Smart weather insights with seasonality and live forecasts",
                      "🌍 Interactive Globe. Explore destinations and jump to curated picks",
                      "🎙️ Built-in travel chatbot with voice input and multilingual replies",
                      "🗺️ Map links, timings, budgets and local tips in every plan",
                      "🔁 Save, edit and re-generate any trip in seconds",
                      "🏢 Corporate travel workflows and approvals",
                      "💍 Destination wedding planning support",
                      "🏨 Hotel campaign and influencer matchmaking tools.",
                    ].map((point, idx) => (
                      <li
                        key={idx}
                        className="feature-point"
                        style={{ marginBottom: "10px" }}
                      >
                        <span className="emoji">{point.split(" ")[0]}</span>
                        <span className="text">
                          {point.split(" ").slice(1).join(" ")}
                        </span>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* // Option B: Quote Style Block */}
        <div
          style={{
            borderLeft: "5px solid #66fcf1",
            padding: "32px 24px",
            maxWidth: "700px",
            margin: "80px auto",
            // background: "rgba(255,255,255,0.08)",
            background: "rgba(0, 0, 0, 0.25)",
            borderRadius: "12px",
            color: "#fff",
            fontStyle: "italic",
            boxShadow: "0 0 15px rgba(0,0,0,0.2)",
          }}
        >
          <h3
            style={{
              fontSize: "22px",
              fontWeight: "700",
              marginBottom: "16px",
              fontStyle: "normal",
            }}
          >
            🌟 What Sets TravXplo Apart
          </h3>
          <p style={{ marginBottom: "16px" }}>
            “At TravXplo, we don’t just plan trips, we design experiences.
            Powered by AI and inspired by wanderlust, our goal is to make each
            journey smarter, richer, and more personal.”
          </p>
          <p
            style={{ color: "#66fcf1", fontStyle: "normal", fontWeight: "600" }}
          >
            🚀 Join the movement and let’s build the future of travel, together.
          </p>
        </div>
      </section>
      <div ref={contactRef}>
        <ContactUs />
      </div>

      <Chatbot />
      <WhatsAppButton place="above" />
    </div>
  );
};

export default Home;
